export default __webpack_public_path__ + "static/media/ico-close.7480e542.svg";